import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { NFLookupUnit } from "../../../Shared/NewForms/NFLookupUnit";

export const ProductionAndSalesWIthPaymentsDetilSalary = () => {
    const tableName = "products";
    const { t } = useTranslation();

    useEffect(() => {}, []);

    return (
        <>
            <NFormTable fieldArray={"salary"}>
                <NFLookupUnit
                    title={t("Unit")}
                    fieldName="unitId"
                    width={250}
                />
                <NFLookupProduct
                    title={t("Job")}
                    fieldName="jobId"
                    width={250}
                />
                <NFIntInput
                    title={t("Quantity")}
                    fieldName="quantity"
                    width={200}
                />
                <NFIntInput title={t("price")} fieldName="price" width={200} />
                <NFIntInput
                    title={t("Amount")}
                    fieldName="amount"
                    width={250}
                />
                <NFLookupAccount
                    title={t("Account")}
                    fieldName="accountId"
                    width={250}
                />
                <NFLookupProduct
                    title={t("Product")}
                    fieldName="productId"
                    width={250}
                />
            </NFormTable>
        </>
    );
};
